import { useEffect, useMemo, useState } from 'react'
import PlacowkaService from '@/services/PlacowkaService'

function cleanText(value) {
	const text = `${value || ''}`.trim()

	if (!text || /^<\s*a\b/i.test(text)) return ''

	return text.replace(/<[^>]*>/g, '').trim()
}

function formatPlacowkaLabel(item) {
	const name = cleanText(item?.nazwa) || cleanText(item?.adres) || '-'
	const cityName = cleanText(item?.id_miasto?.nazwa)
	return cityName ? `${name} (${cityName})` : name
}

export default function usePlacowkaFilterModal(isOpen, selectedPlacowkaId) {
	const [searchTerm, setSearchTerm] = useState('')
	const [items, setItems] = useState([])
	const [loading, setLoading] = useState(false)
	const [error, setError] = useState(null)
	const [activeId, setActiveId] = useState(selectedPlacowkaId || '')

	useEffect(() => {
		if (!isOpen) return
		setActiveId(selectedPlacowkaId || '')
	}, [isOpen, selectedPlacowkaId])

	useEffect(() => {
		if (!isOpen) return
		let cancelled = false
		const loadItems = async () => {
			setLoading(true)
			setError(null)
			const query = (searchTerm || '').trim()
			const options = query
				? { limit: 200, sortColumn: 'nazwa', sortDirection: 'asc' }
				: { limit: 200, sortColumn: '_id', sortDirection: 'desc' }
			const result = query
				? await PlacowkaService.search(query, options)
				: await PlacowkaService.getAll(options)
			if (cancelled) return
			if (result?.error) {
				setError(result.error)
				setItems([])
			} else {
				setItems(Array.isArray(result?.data) ? result.data : [])
			}
			setLoading(false)
		}
		const timer = setTimeout(loadItems, 200)
		return () => {
			cancelled = true
			clearTimeout(timer)
		}
	}, [isOpen, searchTerm])

	const selectedName = useMemo(() => {
		const selected = items.find(item => (item?._id || item?.id) === activeId)
		return selected ? formatPlacowkaLabel(selected) : ''
	}, [items, activeId])

	return {
		searchTerm,
		setSearchTerm,
		items,
		loading,
		error,
		activeId,
		setActiveId,
		selectedName,
		labelAccessor: formatPlacowkaLabel,
		clearFilter: () => setActiveId(''),
	}
}
